/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintDocumenti
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function() {
    'use strict';
    var CdintDocumentiCtrl = function(
        $http,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        labelSrvc,
        messaggiFctr,
        propostaCartaDebitoIntSrvc,
        $uibModal,
        userSrvc
    ) {
        this.$http = $http;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$cacheFactory = $cacheFactory;
        this.messaggiFctr = messaggiFctr;
        this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
        this.CONSTANTS = CONSTANTS;
        this.$uibModal = $uibModal;
        this.userSrvc = userSrvc,
        $scope.msg = labelSrvc.getLabel;

        /**
         * Indica se il caricamento delle labels è andato a buon fine
         */
        this.labelsPronte = false;

        /**
         * Indica se la pratica è già presa in carico
         */
        this.isPresaInCarico = false;

        /**
         * Indica se la pratica è già presa in carico
         */
        this.isRilasciaPratica = false;

        /**
         * Riferimento allo spinner globale
         */
        this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

        /**
         * Copia dei dati pratica
         */
        this.datiPratica = null;

        /**
         * Flag che indica se prosegui è abilitato
         */
        this.isStatoCorretto = false;

        /**
         * Flag che indica se tutti i documenti sono stati firmati
         */
        this.documentiFirmati = false;

        /**
         * Riferimento interno al controller per recuperare i valori nelle funzioni
         */
        var self = this;

        /**
         * Implementazione nel service della funzione di abilitazione torna indietro nella pratica
         */
        this.propostaCartaDebitoIntSrvc.indietroAbilitato = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
         */
        this.propostaCartaDebitoIntSrvc.salvaAbilitato = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
         */
        this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function() {
            return self.getIsStatoCorretto() && self.documentiFirmati;
        };

        /**
         * Implementazione nel service della funzione di visualizzazione bottone prosegui
         */
        this.propostaCartaDebitoIntSrvc.proseguiVisibile = function() {
            return false;
        };

        /**
         * Implementazione nel service della funzione completaVisibile
         */
        this.propostaCartaDebitoIntSrvc.completaVisibile = function() {
            //    	return self.getIsStatoCorretto();
            if (
                (!self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile() &&
                    self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) ||
                (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA &&
                		!(self.propostaCartaDebitoIntSrvc.checkCanale(self.datiPratica.canale, self.userSrvc.user.app)))
            ) {
                return true;
            } else {
                return false;
            }
        };
        
        /**
         * Implementazione nel service della funzione rifiutaVisibile
         */
        this.propostaCartaDebitoIntSrvc.rifiutaVisibile = function() {
            //    	return self.getIsStatoCorretto();
            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
                return true;
            } else {
                return false;
            }
        };

        /**
         * Verifico se la pratica si trova in uno degli stati da cui è possibile avviare il completamento
         * @returns
         */
        this.getIsStatoCorretto = function() {
            return (
                self.datiPratica &&
                ((self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 3) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.CONSOLIDATA && self.datiPratica.step === 6) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 1) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 2) ||
                    (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA && self.datiPratica.step === 3))
            );
        };

        /**
         * Resta in ascolto del cambiamento sulla listaStatiDocumenti che contiene i documenti firmati
         */
        $scope.$watch(
            'listaStatiDocumenti',
            function(newValue, oldValue, $scope) {
                // aggiorno i dati della pratica da quelli restituiti dal widget documentale nello scope
                self.datiPratica = $scope.cdintDocumentiCtrl.datiPratica;

                if (angular.isArray(newValue)) {
                    if (newValue.length === 0) {
                        self.documentiFirmati = true;
                    } else {
                        self.documentiFirmati = !newValue.find(function(value) {
                            return !value.stateValid;
                        });
                    }
                }
            },
            true
        );

        this.verificaPresaInCarico = function() {
            this.propostaCartaDebitoIntSrvc
                .promiseVerificaPresaInCarico(self.propostaCartaDebitoIntSrvc.datiPratica.idPratica)
                .then(
                    function(response) {
                        if (self.messaggiFctr.processaResponse(response)) {
                            return;
                        }

                        if (response.data.presaInCaricoAbilitata) {
	                        if (!response.data.presaInCaricoInCorso) {
	                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
	                                self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
	                                    return true;
	                                };
	                            }
	
	                            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
	                                return false;
	                            };
	                        } else {
	                            self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
	                                return false;
	                            };
	                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
	                                self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
	                                    return true;
	                                };
	                            }
	                        }
                        }else {
                        	self.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function() {
                                return false;
                            };
                            self.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function() {
                                return false;
                            };
                            if (self.datiPratica.stato === CONSTANTS.STATO_PRATICA.PRESENTATA) {
                                self.propostaCartaDebitoIntSrvc.completaVisibile = function() {
                                    return false;
                                };
                                self.propostaCartaDebitoIntSrvc.rifiutaVisibile = function() {
                                	return false;
                                };
    						}
                        }
                    },
                    function(reason) {
                        self.messaggiFctr.processaResponse(reason);

                        self.loggerSrvc.log(
                            'CdintPropostaCartaDebitoIntCtrl',
                            self.loggerSrvc.SEVERE,
                            'Errore verifica PresaInCarico per la pratica ID ' +
                            self.idPratica +
                            ': ' +
                            self.loggerSrvc.formattaMessaggio(reason)
                        );
                    }
                );
        };

        /**
         *  Funzione richiamata all'avvio del controller
         */
        this.init = function() {
            labelSrvc.labelsPronte.then(function() {
                self.labelsPronte = true;

                // Copio i dati pratica e forzo la creazione del campo naturaGiuridica sull'intestatario
                // per compatibilità con gli widget
                var newDatiPratica = JSON.parse(JSON.stringify(self.propostaCartaDebitoIntSrvc.datiPratica));
                if (newDatiPratica) {
                    newDatiPratica.intestatario.naturaGiuridica = newDatiPratica.intestatario.formaCostitutiva;
                    self.datiPratica = newDatiPratica;
                    self.isStatoCorretto = self.getIsStatoCorretto();
                }

                self.verificaPresaInCarico();
            });
        };

        self.init();
    };

    CdintDocumentiCtrl.$inject = [
        '$http',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'CDINT_CONSTANTS',
        'CdintLabelSrvc',
        'CdintMessaggiFctr',
        'CdintPropostaCartaDebitoIntSrvc',
        '$uibModal',
        'CdintUserSrvc',
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT + CONSTANTS.COMPONENTS_PATH + 'cdintPropostaCartaDebitoInt/cdintDocumenti/cdintDocumenti.html'
        );
    };

    TemplateUrl.$inject = ['CDINT_CONSTANTS'];

    var CdintDocumentiComponent = {
        controller: CdintDocumentiCtrl,
        controllerAs: 'cdintDocumentiCtrl',
        templateUrl: TemplateUrl
    };

    angular.module('cbl.cartadebitoint.wa').component('cdintDocumenti', CdintDocumentiComponent);
})();


//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintDocumenti/cdintDocumenti.cmpt.js
// module id = 9
// module chunks = 0